import React from "react";
import AccountHeader from "../components/header/AccountHeader";
import AccountSidebar from "../components/sidebar/AccountSidebar";

const AccountLayout = ({ children, noSidebar }) => {
  return (
    <div className="flex flex-col h-screen bg-[#F4FAF1]">
      {!noSidebar && <AccountHeader />}
      <div className="flex flex-1 h-screen overflow-hidden">
        {!noSidebar && <AccountSidebar />}
        <main className={"flex-1 overflow-y-auto" + `${noSidebar ? "" : " p-4 sm:ml-1"}`}>{children}</main>
      </div>
    </div >
  );
};

export default AccountLayout;
